import apiClient from './apiClient';
import {
  ExternalApiCredential,
  ExternalApiCredentialCreateResult,
  ExternalApiPermission,
  ExternalApiResourceDefinition,
  ExternalApiResponse
} from '../types/externalApi.types';

class ExternalApiSettingsService {
  private baseURL = '/external/settings';

  async getCredentials(): Promise<ExternalApiCredential | null> {
    const response = await apiClient.get<ExternalApiResponse<ExternalApiCredential | null>>(
      `${this.baseURL}/credentials`
    );
    if (!response.data.success) {
      throw new Error(response.data.message || response.data.error || 'Erro ao carregar credenciais');
    }
    return response.data.data || null;
  }

  async createCredentials(name: string): Promise<ExternalApiCredentialCreateResult> {
    const response = await apiClient.post<ExternalApiResponse<ExternalApiCredentialCreateResult>>(
      `${this.baseURL}/credentials`,
      { name }
    );
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || response.data.error || 'Erro ao gerar credenciais');
    }
    return response.data.data;
  }

  async rotateSecret(): Promise<ExternalApiCredentialCreateResult> {
    const response = await apiClient.post<ExternalApiResponse<ExternalApiCredentialCreateResult>>(
      `${this.baseURL}/credentials/rotate-secret`
    );
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || response.data.error || 'Erro ao rotacionar secret');
    }
    return response.data.data;
  }

  async setCredentialStatus(isActive: boolean): Promise<ExternalApiCredential> {
    const response = await apiClient.patch<ExternalApiResponse<ExternalApiCredential>>(
      `${this.baseURL}/credentials/status`,
      { is_active: isActive }
    );
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || response.data.error || 'Erro ao atualizar status da credencial');
    }
    return response.data.data;
  }

  async getPermissions(): Promise<ExternalApiPermission[]> {
    const response = await apiClient.get<ExternalApiResponse<ExternalApiPermission[]>>(
      `${this.baseURL}/permissions`
    );
    if (!response.data.success) {
      throw new Error(response.data.message || response.data.error || 'Erro ao carregar permissões');
    }
    return response.data.data || [];
  }

  async updatePermissions(permissions: ExternalApiPermission[]): Promise<ExternalApiPermission[]> {
    const response = await apiClient.put<ExternalApiResponse<ExternalApiPermission[]>>(
      `${this.baseURL}/permissions`,
      { permissions }
    );
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || response.data.error || 'Erro ao atualizar permissões');
    }
    return response.data.data;
  }

  async getResourcesCatalog(): Promise<ExternalApiResourceDefinition[]> {
    const response = await apiClient.get<ExternalApiResponse<ExternalApiResourceDefinition[]>>(
      `${this.baseURL}/resources`
    );
    if (!response.data.success) {
      throw new Error(response.data.message || response.data.error || 'Erro ao carregar recursos');
    }
    return response.data.data || [];
  }
}

export const externalApiSettingsService = new ExternalApiSettingsService();

